export default __webpack_public_path__ + "static/media/telegram.8231da56.svg";